import Quote from './Quote'
import QuoteHeader from './QuoteHeader'

export * from './Quote'
export * from './QuoteHeader'
export { QuoteHeader }
export default Quote
